import { useState, useCallback } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import logToGoogleSheet from '../utils/SendLogs';
const backendURL = window.__ENV && window.__ENV.backendURL;
const axiosClient = axios.create({ baseURL: `${backendURL}`, timeout: 20000, withCredentials: true, credentials: 'include' });
const config = { headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };

export default function useUser({showPiAds,setShowProgress,setOpenLogInModal}) {
  const [userid, setUserid] = useState('');
  const [userObj, setUserObj] = useState();
  const [user, setUser] = useState();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loggedin, setLoggedin] = useState('false');
  const [isUserObjSet, setIsUserObjSet] = useState(false);
  const [tempUserToken, setTempUserToken] = useState('');
  const [istmpTokenLoaded, setIstmpTokenLoaded] = useState(false);
  const [favorites, setFovirites] = useState();
  const [isSessionVersionSet, setIsSessionVersionSet] = useState(false);
  const [sessionVersion,setSessionVersion] = useState(localStorage.getItem('sessionVersion'));
   const history = useHistory();
  // Extracted functions
  const handleLoadUser = useCallback(() => {
    try {
      var _userObj = JSON.parse(localStorage.getItem('user'));
      setUserObj(_userObj);
      setUser(_userObj.user);
    } catch (err) {
      console.log(err);
    }
  }, []);
  
  const logOut = useCallback(async (userid) => {
    const refreshToken = localStorage.getItem('refreshToken');
    const url = `${process.env.REACT_APP_SERVER_URL}/user/logout/${userid}`;
    return axiosClient.delete(url, { userId: userid, token: refreshToken }, config);
  }, []);
  
const handleLogOut = useCallback(async (userid) => {
    await logOut(userid).then((response) => {
         const privacyterms = JSON.parse(localStorage.getItem('privacyterms'))
          const sessionVersion = localStorage.getItem('sessionVersion');
          localStorage.setItem('sessionVersion', sessionVersion || 'v1');


      if (response.data.status === 200) {
           localStorage.clear();

        setUserObj({});
        setUser({});
        localStorage.setItem('privacyterms', JSON.stringify(privacyterms));
        localStorage.setItem('sessionVersion', sessionVersion || 'v1');
        setLoggedin(false);
        history.push('/account');
      }
    });
  }, [history, logOut]);

  const authenticateToken = useCallback(async (user) => {
    const accessToken = localStorage.getItem('accessToken');
    const url = `${process.env.REACT_APP_SERVER_URL}/user/authenticate`;
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      timeout: 20000, withCredentials: true, credentials: 'include',
    };
    await axiosClient.post(url, {}, options).then((response) => {
      if (response.data.status === 403) {
        // handle expired token
        try {
          if (user._id === undefined) {
            handleLoadUser();
          } else {
            handleLogOut(user._id);
          }
        } catch (err) {
          console.log(err);
        }
      }
    });
  }, [handleLoadUser, handleLogOut]);

 

  const getAccessToken = useCallback(async (_id) => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      const url = `${process.env.REACT_APP_SERVER_URL}/user/token`;
      return axiosClient.post(url, { userId: _id, token: refreshToken }, config);
    }
  }, []);

  const getCurrentUser = useCallback(async () => {
    const url = `${process.env.REACT_APP_SERVER_URL}/session/currentuser`;
    return axiosClient.get(url, {}, config);
  }, []);

  
 const hanldegetAccessToken = useCallback(async (_id) => {
    await getAccessToken(_id).then((response) => {
      if (response !== undefined && response.data.status === 200) {
        localStorage.setItem('accessToken', response.data.accessToken);
      }
    });
  }, [getAccessToken]);
 



  const signInUser = useCallback(async (authResult, scopes) => {
    setShowProgress(true);

    axiosClient.post('/user/signin', { authResult }).then((response) => {
      try {

        const userObj = response.data;
        setUserObj(response.data);
        localStorage.setItem('_id', userObj.user._id);
        localStorage.setItem('uid', userObj.user.uid);
        localStorage.setItem('user', JSON.stringify(userObj));
        localStorage.setItem('stores', JSON.stringify(userObj.stores));
        localStorage.setItem('loggedin', true);
        localStorage.setItem('accessToken', userObj.accessToken);
        localStorage.setItem('refreshToken', userObj.refreshToken);
        localStorage.setItem('confirmed', userObj.user.confirmed);
        localStorage.setItem('privacyterms', JSON.stringify({ policy: userObj.user.accept_privacy_policy, terms: userObj.user.accept_privacy_policy }));
        // On login
        localStorage.setItem('sessionVersion', userObj.sessionVersion || 'v1'); // Default to 'v1' if not provided

        setUser(userObj.user);
        setLoggedin(localStorage.getItem('loggedin'));
        setShowProgress(false);
        setOpenLogInModal(false);
        showPiAds()
      } catch (err) {
        logToGoogleSheet(`Client : Error during sign-in process: ${err.message}`);
        console.log(err);
      }
    });
  }, [setOpenLogInModal, setShowProgress, showPiAds]);


  const signIn = useCallback(async (scopes, onIncompletePaymentFound) => {
    try {

      const authResult = await window.Pi.authenticate(scopes, onIncompletePaymentFound);
            logToGoogleSheet(`Client : User Authenticated using PSDK  : ${JSON.stringify(authResult)}`);

      signInUser(authResult, scopes);
    } catch (err) {
      logToGoogleSheet(`Client : Error during Pi SDK authentication: ${err.message}`);
      console.log(err);
    }
  }, [signInUser]);

  return {
    userid,
    userObj,
    user,
    isAuthenticated,
    loggedin,
    isUserObjSet,
    tempUserToken,
    istmpTokenLoaded,
    favorites,
    sessionVersion,
    isSessionVersionSet,
    setSessionVersion,
    setUserObj,
    setUser,
    setIsAuthenticated,
    setUserid,
    setLoggedin,
    setIsUserObjSet,
    setTempUserToken,
    setIstmpTokenLoaded,
    setFovirites,
    setIsSessionVersionSet,
    handleLoadUser,
    signIn,
    signInUser,
    handleLogOut,
    logOut,
    authenticateToken,
    hanldegetAccessToken,
    getAccessToken,
    getCurrentUser,
  };
}
